import { doc, getDoc, setDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../../../firebase"; // Firebase setup file

const useFirestoreStorage = <T>(key: string, initialValue: T, userId: string): [T, (value: T) => void] => {
  const [storedValue, setStoredValue] = useState<T>(initialValue);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, "users", userId); // Store user settings in "users" collection
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          if (data[key]) {
            setStoredValue(data[key]);
          }
        }
      } catch (error) {
        console.error("Error loading data from Firestore:", error);
      }
    };

    fetchData();
  }, [key, userId]);

  const setValue = async (value: T) => {
    setStoredValue(value);
    try {
      await setDoc(
        doc(db, "users", userId),
        { [key]: value }, // Only update the specific key
        { merge: true }, // Preserve other user settings
      );
    } catch (error) {
      console.error("Error saving data to Firestore:", error);
    }
  };

  return [storedValue, setValue];
};

export default useFirestoreStorage;
